import { Car } from 'lucide-react';

/**
 * The drive to (above) or back from (below) a block in the calendar: a hatched strip in the
 * block's colour. Tapping it opens the activity, like tapping the block.
 */
export function TravelStrip({
  minutes,
  color,
  top,
  height,
  side,
  onOpen,
}: {
  minutes: number;
  color: string;
  top: number;
  height: number;
  side: 'before' | 'after';
  onOpen: () => void;
}) {
  if (minutes <= 0 || height < 2) return null;
  return (
    <button
      type="button"
      tabIndex={-1}
      aria-hidden
      data-testid={`travel-${side}`}
      onClick={onOpen}
      className="absolute inset-x-0 flex items-center gap-1 overflow-hidden px-1.5 text-[11px] font-medium text-text-2 tabular-nums"
      style={{
        top,
        height,
        borderRadius: side === 'before' ? '6px 6px 0 0' : '0 0 6px 6px',
        background: `repeating-linear-gradient(135deg, color-mix(in srgb, ${color} 14%, var(--surface)) 0 5px, var(--surface) 5px 9px)`,
        boxShadow: `inset 3px 0 0 color-mix(in srgb, ${color} 45%, transparent)`,
      }}
    >
      {height >= 14 && (
        <>
          <Car size={11} className="shrink-0" />
          {minutes} min
        </>
      )}
    </button>
  );
}
